var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "tab-nav": true, colored: _vm.coloredBackground } },
    [
      !_vm.breakable
        ? _c(
            "nobr",
            _vm._l(_vm.tabs, function(tab) {
              return !_vm.noRoute && !tab.dissabled
                ? _c(
                    "router-link",
                    {
                      key: tab.name,
                      class: _vm.getRouteClass(tab.name),
                      attrs: { to: { name: tab.route, params: tab.params } }
                    },
                    [
                      _vm._v(
                        "\n\n      " + _vm._s(_vm.$t(tab.label)) + "\n    "
                      )
                    ]
                  )
                : _vm._l(_vm.tabs, function(tab) {
                    return _c(
                      "div",
                      { key: tab.name, class: _vm.getRouteClass(tab.name) },
                      [
                        _c(
                          "p",
                          {
                            class: _vm.getTabClassP(tab, _vm.active),
                            on: {
                              click: function($event) {
                                return _vm.tabChange(tab.route)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n\n        " +
                                _vm._s(_vm.$t(tab.label)) +
                                "\n      "
                            )
                          ]
                        )
                      ]
                    )
                  })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.breakable
        ? _c(
            "div",
            { staticClass: "text-center text-md-left" },
            _vm._l(_vm.tabs, function(tab) {
              return !_vm.noRoute && !tab.dissabled
                ? _c(
                    "router-link",
                    {
                      key: tab.name,
                      class: _vm.getRouteClass(tab.name),
                      attrs: { to: { name: tab.route } }
                    },
                    [
                      _vm._v(
                        "\n\n      " + _vm._s(_vm.$t(tab.label)) + "\n    "
                      )
                    ]
                  )
                : _vm._l(_vm.tabs, function(tab) {
                    return _c(
                      "div",
                      { key: tab.name, class: _vm.getRouteClass(tab.name) },
                      [
                        _c(
                          "p",
                          {
                            class: _vm.getTabClassP(tab, _vm.active),
                            on: {
                              click: function($event) {
                                return _vm.tabChange(tab.route)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n\n        " +
                                _vm._s(_vm.$t(tab.label)) +
                                "\n      "
                            )
                          ]
                        )
                      ]
                    )
                  })
            }),
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-649bef25", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-649bef25","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/action/TabNav.vue
// module id = null
// module chunks = 